import { listParametres } from "../api/restaurant";
import Parametres from "../types/api/Parametres";

export function getDayBefore(d: Date) : Date {
    let date = new Date(d);
    date.setDate(date.getDate()-1);
    return date;
}


export function getWeekNumber(d: Date) : number {
    // Copy date so don't modify original
    d = new Date(Date.UTC(d.getFullYear(), d.getMonth(), d.getDate()));
    // Set to nearest Thursday: current date + 4 - current day number
    // Make Sunday's day number 7
    d.setUTCDate(d.getUTCDate() + 4 - (d.getUTCDay()||7));
    // Get first day of year
    let yearStart = new Date(Date.UTC(d.getUTCFullYear(),0,1));
    // Calculate full weeks to nearest Thursday
    let weekNo = Math.ceil(( ( (d.getTime() - yearStart.getTime()) / 86400000) + 1)/7);
    // Return array of year and week number
    return weekNo;
}

export function numberToMonthName(n: number) : string {
    switch(n){
        case 0: return "Janvier";
        case 1: return "Février";
        case 2: return "Mars";
        case 3: return "Avril";
        case 4: return "Mai";
        case 5: return "Juin";
        case 6: return "Juillet";
        case 7: return "Août";
        case 8: return "Septembre";
        case 9: return "Octobre";
        case 10: return "Novembre";
        case 11: return "Décembre";
        default: return "Inconnu";
    }
}

export function getDateMonthPreviousMonday(d: Date){
    let date = new Date(d);
    while(date.getDay() !== 1){
        date.setDate(date.getDate()-1);
    }
    return date.getDate() + " " + numberToMonthName(date.getMonth());
}

export function getDatePreviousMonday(d: Date){
    let date = new Date(d);
    while(date.getDay() !== 1){
        date.setDate(date.getDate()-1);
    }
    return date.getDate();
}



export function getDateMonthNextSunday(d: Date) {
    let date = new Date(d);
    while(date.getDay() !== 0){
        date.setDate(date.getDate()+1);
    }
    return date.getDate() + " " + numberToMonthName(date.getMonth());
}

export function getDateNextSunday(d: Date) {
    let date = new Date(d);
    while(date.getDay() !== 0){
        date.setDate(date.getDate()+1);
    }
    return date.getDate();
}

export function getMonthName(d: Date) : string {
    return numberToMonthName(d.getMonth());
}


export function getYearOfDate(d: Date) {
    return d.getFullYear();
}

export function getPreviousSevenDays(): string[] {
    const days: string[] = [];
    const today = new Date();
    
    for (let i = 7; i > 0; i--) {
        const previousDay = new Date();
        previousDay.setDate(today.getDate() - i);
        
        // Get day name in French
        const dayName = previousDay.toLocaleDateString('fr-FR', { weekday: 'long' });
        // Capitalize first letter
        const formattedDayName = dayName.charAt(0).toUpperCase() + dayName.slice(1);
        
        days.push(formattedDayName);
    }
    
    return days;
}

export function indexToShift(index: number): string {
    switch(index){
        case 0: return "MondayNoon";
        case 1: return "MondayEvening";
        case 2: return "TuesdayNoon";
        case 3: return "TuesdayEvening";
        case 4: return "WednesdayNoon";
        case 5: return "WednesdayEvening";
        case 6: return "ThursdayNoon";
        case 7: return "ThursdayEvening";
        case 8: return "FridayNoon";
        case 9: return "FridayEvening";
        case 10: return "SaturdayNoon";
        case 11: return "SaturdayEvening";
        case 12: return "SundayNoon";
        case 13: return "SundayEvening";
        default: return "Inconnu";
    }
}

export function translateDayName(day: string): string {
    switch(day){
        case "MONDAY": return "Lundi";
        case "TUESDAY": return "Mardi";
        case "WEDNESDAY": return "Mercredi";
        case "THURSDAY": return "Jeudi";
        case "FRIDAY": return "Vendredi";
        case "SATURDAY": return "Samedi";
        case "SUNDAY": return "Dimanche";
        default: return day;
    }
}
export function translateService(shift: string): string {
    switch(shift){
        case "NOON": return "Midi";
        case "EVENING": return "Soir";
        default: return shift;
    }
}

export function dayIndexToDayName(index: number): string {
    switch(index){
        case 0: return "MONDAY";
        case 1: return "TUESDAY";
        case 2: return "WEDNESDAY";
        case 3: return "THURSDAY";
        case 4: return "FRIDAY";
        case 5: return "SATURDAY";
        case 6: return "SUNDAY";
        default: return "Inconnu";
    }
}

export function dayNameToDayIndex(day: string): number {
    switch(day){
        case "MONDAY": return 0;
        case "TUESDAY": return 1;
        case "WEDNESDAY": return 2;
        case "THURSDAY": return 3;
        case "FRIDAY": return 4;
        case "SATURDAY": return 5;
        case "SUNDAY": return 6;
        default: return -1;
    }
}

export async function loadParams() {
  const res = await listParametres();

  if (!res || res.code !== 200 || !res.data) {
    throw new Error("API error");
  }

  return new Map(
    (res.data as Parametres[]).map(p => [p.key, p.value])
  );
};
